import React, { useEffect } from 'react';
import Store from 'store/store';
import Router from 'components/Router/Router';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import CaseSubHeader from './CaseSubHeader';
import MpsHubSubHeader from './MpsHubSubHeader';

const { connect, actions } = Store;
const { useParams } = Router;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    subHeader: {
      backgroundColor: '#f7f7f7',
      display: 'flex',
      alignItems: 'center',
      height: '30px',
      cursor: 'default',
      padding: '0 2rem',
      fontSize: '0.8rem',
      boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
      gap: '2px',
      zIndex: theme.zIndex.drawer
    },
    link: {
      cursor: 'pointer',
      '&:hover': {
        textDecoration: 'underline'
      }
    }
  })
);

const SubHeader = ({ clearCase }: any) => {
  const classes = useStyles();
  const { portfolio, provider } = useParams() as any;
  const isCaseSeleted = !!portfolio;
  const isMpsHubProviderSelected = !!provider;

  useEffect(() => {
    if (!isCaseSeleted) {
      clearCase();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderComponent = () => {
    if (isCaseSeleted) {
      return <CaseSubHeader classes={classes} />;
    }

    if (isMpsHubProviderSelected) {
      return <MpsHubSubHeader classes={classes} />;
    }

    return null;
  };

  const component = renderComponent();

  return component ? (
    <div className={classes.subHeader}>{component}</div>
  ) : (
    <></>
  );
};

export default connect(() => ({}), {
  clearCase: actions.caseActions.clearCase
})(SubHeader);
